import type { CityConfig } from "../city-template/types";

export const newBernConfig: CityConfig = {
  city: "New Bern",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "new-bern",
  route: "/new-bern",
  title: "Emergency Passport New Bern, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in New Bern, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Craven County and coastal North Carolina. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in New Bern, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help New Bern and Craven County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=New%20Bern%20North%20Carolina%20downtown%20at%20golden%20hour%20with%20historic%20Tryon%20Palace%20gardens%20and%20colonial%20architecture%2C%20charming%20riverfront%20district%20along%20the%20Neuse%20River%20with%20sailboats%20and%20waterfront%20promenade%2C%20warm%20sunset%20light%20over%20Craven%20County%20coastal%20town%2C%20lush%20green%20trees%20and%20historic%20brick%20buildings%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20colonial%20southern%20elegance%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=newbern-hero-nc-001&orientation=landscape",
  heroImageAlt: "New Bern North Carolina downtown with Tryon Palace gardens and historic waterfront at golden hour",
  geoPosition: "35.1085;-77.0441",
  geoPlacename: "New Bern, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 320 miles north of New Bern — about 5.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "New Bern", zips: "28560, 28561, 28562, 28563, 28564" },
    { name: "Havelock", zips: "28532, 28533" },
    { name: "James City", zips: "28560" },
    { name: "Trent Woods", zips: "28562" },
    { name: "Bridgeton", zips: "28519" },
    { name: "River Bend", zips: "28562" },
    { name: "Cove City", zips: "28523" },
    { name: "Vanceboro", zips: "28586" },
    { name: "Pollocksville", zips: "28573" },
    { name: "Grantsboro", zips: "28529" },
    { name: "Oriental", zips: "28571" },
    { name: "Beaufort", zips: "28516" },
    { name: "Morehead City", zips: "28557" },
    { name: "Jacksonville", zips: "28540, 28541, 28542, 28543, 28544, 28545, 28546, 28547" },
    { name: "Greenville", zips: "27834, 27835, 27836, 27858" },
    { name: "Kinston", zips: "28501, 28502, 28503, 28504" },
    { name: "Goldsboro", zips: "27530, 27531, 27532, 27533, 27534" },
    { name: "Wilmington", zips: "28401, 28402, 28403, 28404, 28405, 28406, 28409, 28411, 28412" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Craven County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Coastal NC Hub", desc: "Serving New Bern, Havelock, and all of Craven County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Jacksonville, NC", route: "/jacksonville-nc" },
    { name: "Fast passport renewal in Wilmington, NC", route: "/wilmington" },
    { name: "Emergency passport help in Greenville, NC", route: "/greenville" },
    { name: "Urgent passport services in Goldsboro, NC", route: "/goldsboro" },
    { name: "Passport courier services in Wilson, NC", route: "/wilson" },
    { name: "Same-day passport help in Kinston, NC", route: "/kinston" },
  ],
  fpcOfficeNote: "Fast Passport Center serves New Bern remotely via secure courier. We do not have a walk-in office in New Bern — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Craven County and coastal North Carolina travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Craven County and coastal North Carolina",
  serviceAreaIntro: "From downtown New Bern's historic Tryon Palace to the Havelock military community, from the Trent Woods suburbs to the waterfront towns of Bridgeton and River Bend — Fast Passport Center serves the entire New Bern region. We regularly help travelers from Jacksonville, Beaufort, Morehead City, Greenville, Kinston, Goldsboro, and Wilmington get their passports fast.",
  nearbyCitiesIntro: "We serve all New Bern neighborhoods and the surrounding coastal North Carolina area including Havelock, James City, Trent Woods, Bridgeton, River Bend, Cove City, Vanceboro, Pollocksville, Grantsboro, Oriental, Beaufort, Morehead City, Jacksonville, Greenville, Kinston, Goldsboro, and Wilmington. If you are anywhere in Craven County or coastal North Carolina, we have you covered.",
  howItWorksIntro: "Most New Bern travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "New Bern travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "New Bern and Craven County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in New Bern? Here are the most common ones we hear from Craven County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent New Bern international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Commander James H.",
      location: "New Bern, NC",
      rating: 5,
      text: "Marine stationed at Cherry Point. Needed an emergency passport for a deployment readiness check. Fast Passport Center had it in 24 hours. Military-friendly and understood the urgency.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa R.",
      location: "Havelock, NC",
      rating: 5,
      text: "Family cruise leaving from Port Canaveral in 5 days. My daughter's passport was expired. Fast Passport Center got her a new one in 3 days. Saved our vacation.",
      service: "Child Passport",
    },
    {
      name: "Michael D.",
      location: "New Bern, NC",
      rating: 5,
      text: "Business trip to London in 4 days. Passport renewal completed in 29 hours. The dedicated agent called me with updates twice. Outstanding service for coastal NC.",
      service: "Passport Renewal",
    },
    {
      name: "Rebecca T.",
      location: "Morehead City, NC",
      rating: 5,
      text: "Lost passport before a diving trip to the Bahamas. Fast Passport Center had a replacement in 26 hours. The best passport service for anyone on the Crystal Coast.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "newbern-1",
      name: "New Bern Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "800 Broad St",
      city: "New Bern",
      state: "NC",
      zip: "28560",
      phone: "(252) 637-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown New Bern",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary New Bern facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "newbern-2",
      name: "Havelock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "811 E Main St",
      city: "Havelock",
      state: "NC",
      zip: "28532",
      phone: "(252) 447-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles south of New Bern",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Havelock and MCAS Cherry Point residents. Less crowded than main New Bern office.",
      icon: "ri-mail-line",
    },
    {
      id: "newbern-3",
      name: "Jacksonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 New Bridge St",
      city: "Jacksonville",
      state: "NC",
      zip: "28540",
      phone: "(910) 455-0131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles southwest of New Bern",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Camp Lejeune and MCAS New River area. Alternative for military families in Craven County.",
      icon: "ri-mail-line",
    },
    {
      id: "newbern-4",
      name: "Greenville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2210 W Arlington Blvd",
      city: "Greenville",
      state: "NC",
      zip: "27834",
      phone: "(252) 758-6181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles north of New Bern",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major eastern NC facility. Alternative for New Bern north side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "newbern-5",
      name: "Kinston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Washington St",
      city: "Kinston",
      state: "NC",
      zip: "28501",
      phone: "(252) 523-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles northwest of New Bern",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lenoir County. Alternative for New Bern west side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "newbern-6",
      name: "Wilmington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 N 3rd St",
      city: "Wilmington",
      state: "NC",
      zip: "28401",
      phone: "(910) 762-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "90 miles south of New Bern",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major coastal NC facility. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "New Bern photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Craven County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many New Bern applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Craven County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "New Bern travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in New Bern." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your New Bern address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in New Bern before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in New Bern for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in New Bern?", a: "Fast Passport Center offers fast passport renewal in New Bern in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to New Bern?", a: "The nearest regional passport agency to New Bern is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 320 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from New Bern without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near New Bern?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 5.5 hours from New Bern — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Craven County residents." },
    { q: "Do you serve the entire Crystal Coast and coastal NC area?", a: "Absolutely. Fast Passport Center serves the entire Crystal Coast and coastal North Carolina area including New Bern, Havelock, Beaufort, Morehead City, Oriental, Jacksonville, Wilmington, and surrounding communities. Our courier service works seamlessly from any address in Craven County and neighboring coastal counties." },
    { q: "Can I expedite a child passport in New Bern?", a: "Yes. Fast Passport Center expedites child passports in New Bern for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Craven County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in New Bern with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — New Bern", address: "1801 S Glenburnie Rd, New Bern, NC 28562", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — New Bern", address: "2500 Neuse Blvd, New Bern, NC 28562", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — New Bern", address: "3005 Dr M L King Jr Blvd, New Bern, NC 28562", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Havelock", address: "813 E Main St, Havelock, NC 28532", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Jacksonville", address: "1200 Western Blvd, Jacksonville, NC 28546", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Greenville", address: "2100 E Fire Tower Rd, Greenville, NC 27858", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Wilmington", address: "1015 S College Rd, Wilmington, NC 28403", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Kinston", address: "2403 N Heritage St, Kinston, NC 28501", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — New Bern",
      address: "1503 S Glenburnie Rd, New Bern, NC 28562",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Havelock",
      address: "809 E Main St, Havelock, NC 28532",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Craven County south side. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Jacksonville",
      address: "200 New Bridge St, Jacksonville, NC 28540",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Onslow County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Greenville",
      address: "207 E Arlington Blvd, Greenville, NC 27834",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Pitt County office. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "EWN",
      name: "Coastal Carolina Regional Airport",
      distance: "3 miles south of New Bern",
      address: "200 Airport Rd, New Bern, NC 28562",
      note: "Regional airport with American Airlines flights to Charlotte (CLT). Connecting flights available to international destinations. The closest airport for New Bern travelers.",
      flightUrl: "https://www.newbernairport.com/",
      flightLabel: "EWN Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "120 miles west of New Bern",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to Europe, Canada, Mexico, and the Caribbean. The closest major airport for New Bern travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "250 miles west of New Bern",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines hub with the most international flight options from North Carolina. Consider for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Craven County Register of Deeds", url: "https://www.cravencountync.gov/170/Register-of-Deeds", description: "Birth, death, and marriage records for Craven County" },
    { name: "Craven County Superior Court", url: "https://www.nccourts.gov/locations/craven-county", description: "Divorce records and court documents for Craven County" },
  ],
};